import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PurchaseOrders_ds_get_shipmentline_by_shipmentlineIdService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { shipmentLineId: number }): 
  Promise<{ result: { Id?: number, ActualAmount?: number, ActualPackagedAmount?: number, ExpectedAmount?: number, ExpectedPackagedAmount?: number, GrossWeight?: number, NetWeight?: number } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shipmentLineId)) {
      missingRequiredInParams.push('\'shipmentLineId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PurchaseOrders/datasources/ds_get_shipmentline_by_shipmentlineId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      shipmentLineId: number    }) {
        if(isNil(inParams.shipmentLineId)) {
          return true; 
        }
      return false;
    }
}
